<template>
    <button type="button" v-if="previousStage" v-on:click="navigateBack()" v-bind:class="twStyle">
        <font-awesome-icon icon="chevron-left" />
        <span>
            &nbsp; Go Back
        </span>
    </button>
</template>

<script lang="ts">
    import { Vue } from "vue-property-decorator";
    import { Component, Prop, Watch } from "vue-property-decorator";
    import TicketWidgetComponent from "../../TicketWidgetComponent";

    //fontawesome
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

    library.add(faChevronLeft);

    @Component({
        components: {
            FontAwesomeIcon
        }
    })

    export default class PreviousStage extends TicketWidgetComponent {
        @Prop() public twStyle!: string;
        @Prop() public buttonStage!: string;

        previousStage: boolean = true;
        buttonText: string = 'Go Back';
        stage: any = {};

        /**
        * @desc when mounted, grab the current stage and see if its previous stage exists
        */
        mounted() {
            this.stage = this.$root.$data.stages[this.buttonStage];
        }

        /**
        * @desc if the user clicks the previous breadcrumb, it will navigate back one.
        */
        navigateBack() {
            this.showCheckoutError = false;
            this.checkoutErrorMessage = '';
            this.$router.go(-1);

            this.$root.$data.config.stage = this.$route.meta!.stage;
        }
    }
</script>